// 화면의 목록을 엑셀 파일(.xlsx)로 내려받는다 — 명단·배송 기록을 교육청 제출·해지 전 보관용으로 챙길 때 쓴다.
// CSV가 아니라 xlsx로 만드는 이유: 엑셀에서 한글이 깨지지 않고, 전화번호 앞 0이 사라지지 않는다.
import * as XLSX from "xlsx";

export function downloadXlsx(filename: string, sheetName: string, rows: Record<string, string | number>[]) {
  const ws = XLSX.utils.json_to_sheet(rows);
  // 칸 너비 — 가장 긴 값 기준(최대 50)
  const keys = rows.length ? Object.keys(rows[0]) : [];
  ws["!cols"] = keys.map((k) => ({ wch: Math.min(50, Math.max(k.length + 2, ...rows.map((r) => String(r[k] ?? "").length + 2))) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
  XLSX.writeFile(wb, filename);
}
